import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations, languageNames, languageFlags, dateLocales } from "@/i18n/translations";
import { enGB, fr as frLocale } from "date-fns/locale";
import api from "@/lib/api";

const LanguageContext = createContext(null);
const DATE_FNS = { en: enGB, fr: frLocale, cr: frLocale };

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("padel-lang") || "en");

  useEffect(() => {
    localStorage.setItem("padel-lang", lang);
    document.documentElement.setAttribute("lang", lang === "cr" ? "mfe" : lang);
    if (localStorage.getItem("padel_access_token")) api.put("/users/profile", { lang }).catch(() => {});
  }, [lang]);

  const t = useCallback((key, vars) => {
    let s = translations[lang]?.[key] ?? translations.en?.[key] ?? key;
    if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.split(`{${k}}`).join(String(v)); });
    return s;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languageNames, languageFlags, locale: dateLocales[lang], dateFnsLocale: DATE_FNS[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
